import { render, staticRenderFns } from "./SaveQueryDialog.vue?vue&type=template&id=2b8cdfac&scoped=true"
import script from "./SaveQueryDialog.vue?vue&type=script&lang=js"
export * from "./SaveQueryDialog.vue?vue&type=script&lang=js"
import style0 from "./SaveQueryDialog.vue?vue&type=style&index=0&id=2b8cdfac&prod&scoped=true&lang=css"
import style1 from "./SaveQueryDialog.vue?vue&type=style&index=1&id=2b8cdfac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8cdfac",
  null
  
)

export default component.exports